import axios from 'axios';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';

import config from '../../config/config';
import constant from '../../utils/Constant';
import Loader from '../partials/Loader';
import placeholder from '../../assets/images/1080.png'

const {
    EMPTY_STRING: emptyString,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    GET_SERVICE_END_POINT,
    CREATE_VENDORS_END_POINT,
    STATUS_200,
    STATUS_401,
    LOGOUT,
    GER_TAG_END_POINT,
    ZERO,
} = constant;

const UpdateVendor = () => {
    const navigate = useNavigate();

    const [isChecked, setIsChecked] = useState(ZERO);
    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const [vendorStatus, setVendorStatus] = useState(emptyString);
    const [avialableStatus, setAvialableStatus] = useState(emptyString);
    const [images, setImages] = useState([]);
    const [formData, setFormData] = useState({
        category: emptyString,
        title: emptyString,
        location: [],
        website: emptyString,
        priceMin: emptyString,
        priceMax: emptyString,
        description: emptyString,
        insta: emptyString,
        phone: emptyString,
        password: emptyString,
        email: emptyString,
    });

    const [services, setServices] = useState([
        {
            id: Date.now(),
            image: placeholder,
            name: 0,
            price: 0
        }
    ]);

    const fileInputRef = useRef(null);

    // * location array
    const locationArray = [
        'Eastern Cape', 'Free State',
        'Gauteng', 'KwaZulu-Natal',
        'Limpopo', 'Mpumalanga',
        'Northern Cape', 'North West',
        'Western Cape'
    ];

    const locationOptions = locationArray.map((loc) => ({
        value: loc,
        label: loc,
    }));

    //* handle change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        // * if category change then empty service and tags input 
        if (name === 'category') {
            setServices([]);
        }
    };

    // * get token from local storage
    const token = localStorage.getItem('vendor_super_token');

    // * handle remove image
    const handleRemoveImage = (index) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    };

    // * handle upload click
    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // * handle image change
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
        const maxSize = 2 * 1024 * 1024; // 2MB

        const newImages = [];
        let invalidTypeFound = false;
        let invalidSizeFound = false;

        files.forEach((file) => {
            if (!allowedTypes.includes(file.type)) {
                invalidTypeFound = true;
            } else if (file.size > maxSize) {
                invalidSizeFound = true;
            } else {
                newImages.push({
                    file,
                    preview: URL.createObjectURL(file),
                });
            }
        });

        if (invalidTypeFound) {
            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        }
        if (invalidSizeFound) {
            toast.error("Each image must be 2MB or smaller.");
        }

        setImages((prevImages) => {
            const totalImages = prevImages.length + newImages.length;

            if (totalImages > 20) {
                toast.error("Maximum 20 images are allowed.");
                const allowedToAdd = 20 - prevImages.length;
                return [...prevImages, ...newImages.slice(0, allowedToAdd)];
            }

            return [...prevImages, ...newImages];
        });

        // ✅ Reset input to allow same file re-selection
        e.target.value = null;
    };

    // * handle switch change
    const handleSwitchChange = () => {
        setIsChecked(prevState => (prevState ? 0 : 1));
    };

    // * service card validation
    const validateServices = () => {
        const isNameEmpty = services.some((service) => !service.name);
        const isImageEmpty = services.some((service) => service.image === placeholder);

        if (isNameEmpty) {
            toast.error("Service name is required.");
            return false;
        }

        if (isImageEmpty) {
            toast.error("Service image is required.");
            return false;
        }

        return true;
    };

    // * execute create vendor api
    const executeCreateVendorApi = async () => {

        if (validateServices()) {

            if (!formData.category) {
                toast.error('Category is required!');
                return;
            }

            if (!formData.title) {
                toast.error('Name is required!');
                return;
            }

            if (!formData.location) {
                toast.error('Location is required!');
                return;
            }

            if (!formData.email) {
                toast.error('Email required!');
                return;
            }

            // * set loading and disable button
            setLoading(trueValue);
            setDisableButton(trueValue);

            // * create form data
            const data = new FormData();
            data.append('profile', null);
            data.append('category', formData.category);
            data.append('name', formData.title);
            data.append('description', formData.description);
            data.append('location', JSON.stringify(JSON.stringify(formData.location)));
            data.append('min', formData.priceMin);
            data.append('max', formData.priceMax);
            data.append('email', formData.email);
            data.append('phone', formData.phone);
            data.append('password', formData.password);
            data.append('insta', formData.insta);
            data.append('website', formData.website);
            data.append('availability_status', Number(avialableStatus));
            data.append('status', Number(vendorStatus));
            data.append('is_featured', isChecked);

            for (const service of services) {
                data.append('service_name[]', service.name);
                data.append('service_price[]', service.price);

                if (service.image) {
                    const response = await fetch(service.image);
                    const blob = await response.blob();
                    const file = new File([blob], `service_${service.name}.jpg`, { type: blob.type });
                    data.append('service_image[]', file);
                } else {
                    data.append('service_image[]', '');
                }
            }

            const image = images.map(item => item.file);
            image.forEach((img) => {
                data.append('business_images[]', img);
            });

            try {
                const apiUrl = `${config.appBaseUrl + CREATE_VENDORS_END_POINT}`;

                // * execute put request
                const response = await axios.post(apiUrl, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                // * api response
                const apiResponse = response.data;

                // * if response is success
                if (apiResponse.status && apiResponse.code === STATUS_200) {
                    toast.success(apiResponse.message)
                    setTimeout(() => {
                        navigate('/vendors/all')
                    }, [1400])
                }
            } catch (error) {
                handleError(error);
                // * if token is expired
                if (error.response?.data?.code === STATUS_401) {
                    navigate(LOGOUT);
                }
            } finally {
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        }
    };

    //* handle error
    const handleError = (error) => {
        const errorData = error.response?.data?.data;

        if (errorData && typeof errorData === 'object') {
            const firstKey = Object.keys(errorData)[0];
            const firstMessage = errorData[firstKey][0];
            toast.error(firstMessage);
        } else {
            toast.error('Something was broken!');
        }
    };

    // * handle add service
    const handleAddService = () => {
        for (let i = 0; i < services.length; i++) {
            const service = services[i];

            if (!service.name || service.name === 0 || service.name === "") {
                toast.error(`Service ${i + 1}: Name is required`, {
                    toastId: `name-required-${i}`,
                });
                return;
            }

            if (!service.image || service.image === placeholder) {
                toast.error(`Service ${i + 1}: Image is required`, {
                    toastId: `image-required-${i}`,
                });
                return;
            }

            if (!service.price) {
                toast.error(`Service ${i + 1}: Price is required`, {
                    toastId: `price-required-${i}`,
                });
                return;
            }
        }

        const newService = {
            id: Date.now(),
            image: placeholder,
            name: 0,
            price: 0
        };
        setServices([...services, newService]);
    };

    //* handle file change
    const handleFileChange = (e, id) => {
        const updatedServices = services.map((service) => {
            if (service.id === id) {
                return { ...service, image: URL.createObjectURL(e.target.files[0]) };
            }
            return service;
        });
        setServices(updatedServices);
    };

    //* handle input change 
    const handleInputChange = (e, id, field) => {
        const { value } = e.target;
        setServices(prev =>
            prev.map(service =>
                service.id === id ? { ...service, [field]: value } : service
            )
        );
    };

    //* Remove Service
    const handleRemoveService = (id) => {
        const updatedServices = services.filter(service => service.id !== id);
        setServices(updatedServices);
    };

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />
            <div className='page-content px-4' style={{ zIndex: '1' }}>
                <div className='container-fluid'>
                    {/* //* start page title */}
                    <div className='row'>
                        <div className='col-12 px-0'>
                            <div className='page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>Create Vendor</h4>
                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0 d-flex flex-wrap gap-1'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active pointer' onClick={() => navigate(-1)}>Vendors</li>
                                        <li className='breadcrumb-item active'>Create Vendor</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='row'>

                                    {/* //* business infomation */}
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-between rounded-2 mb-3 px-3 py-2" style={{ background: '#e8fff4' }}>
                                                    <label htmlFor="email" className="mb-0 fw-semibold">Business Information</label>
                                                </div>

                                                <div className="row">
                                                    {/* //* category */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='category'>Category</label>
                                                        <select
                                                            name='category'
                                                            id='category'
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.category}
                                                            onChange={handleChange}
                                                        >
                                                            <option value=''>Select a category</option>
                                                            <option value='1'>Mobile Bar</option>
                                                            <option value='2'>Caterer</option>
                                                        </select>
                                                    </div>

                                                    {/* //* business name */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='title'>Business Name</label>
                                                        <input
                                                            type='text'
                                                            name='title'
                                                            id='title'
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.title}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* phone */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='phone'>Phone</label>
                                                        <input
                                                            type='number'
                                                            name='phone'
                                                            id='phone'
                                                            min={0}
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* title */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='email'>Email</label>
                                                        <input
                                                            type='email'
                                                            name='email'
                                                            id='email'
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* location */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='location'>Location</label>
                                                        <Select
                                                            id="location"
                                                            name="location"
                                                            placeholder="Select locations"
                                                            options={locationOptions}
                                                            isMulti
                                                            className='basic-multi-select'
                                                            value={locationOptions.filter(opt => formData.location.includes(opt.value))}
                                                            onChange={(selectedOptions) =>
                                                                handleChange({
                                                                    target: {
                                                                        name: 'location',
                                                                        value: selectedOptions.map((opt) => opt.value),
                                                                    },
                                                                })
                                                            }
                                                        />
                                                    </div>

                                                    {/* //* website */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='website mb-1'>Website</label>
                                                        <input
                                                            type='text'
                                                            name='website'
                                                            id='website'
                                                            className='form-control m-0'
                                                            placeholder='Enter your wesbite'
                                                            value={formData.website}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* price range */}
                                                    {/* <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <div className='d-flex gap-4'>
                                                            <div className='d-flex flex-column'>
                                                                <label>Min Price</label>
                                                                <input
                                                                    type='text'
                                                                    name='priceMin'
                                                                    id='priceMin'
                                                                    className='form-control m-0'
                                                                    placeholder='Min'
                                                                    value={formData.priceMin}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className='d-flex flex-column'>
                                                                <label>Max Price</label>
                                                                <input
                                                                    type='text'
                                                                    name='priceMax'
                                                                    id='priceMax'
                                                                    className='form-control m-0'
                                                                    placeholder='Max'
                                                                    value={formData.priceMax}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                    {/* //* status */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='status_vendor'>Status</label>
                                                        <select name='status_vendor'
                                                            id='status_vendor'
                                                            className='form-select'
                                                            value={vendorStatus}
                                                            onChange={(e) => setVendorStatus(e.target.value)}
                                                        >
                                                            <option value=''>Select status</option>
                                                            <option value={0}>Pending</option>
                                                            <option value={1}>Approve</option>
                                                            <option value={2}>Reject</option>
                                                        </select>
                                                    </div>

                                                    {/* //* is featured */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <div className='d-flex flex-column justify-content-end'>
                                                            <label htmlFor='status_vendor'>Is Feature</label>
                                                            <div className={`d-flex align-items-center justify-content-start py-2 border px-3 rounded-2 ${isChecked ? 'light-golden-bg' : ''}`} style={{ padding: '7px !important' }}>
                                                                <div className='switch-container' onClick={handleSwitchChange} style={{ cursor: 'pointer' }}>
                                                                    <div className={`switch ${isChecked ? 'on' : 'off'}`}>
                                                                        <div className='switch-knob'></div>
                                                                    </div>
                                                                    <span className='ms-2  text-secondary'>Is Featured</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* //* availability status */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='status_vendor'>Availibity Status</label>
                                                        <select name='status_vendor'
                                                            id='status_vendor'
                                                            className='form-select'
                                                            value={avialableStatus}
                                                            onChange={(e) => setAvialableStatus(e.target.value)}
                                                        >
                                                            <option value=''>Select status</option>
                                                            <option value={1}>Active</option>
                                                            <option value={0}>Inactive</option>
                                                        </select>
                                                    </div>

                                                    {/* //* insta */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-3 mb-3'>
                                                        <label htmlFor='insta mb-1'>Instagram</label>
                                                        <input
                                                            type='text'
                                                            name='insta'
                                                            id='insta'
                                                            className='form-control m-0'
                                                            placeholder='Enter your instagram'
                                                            value={formData.insta}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* password */}
                                                    <div className='col-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-3'>
                                                        <label htmlFor='password'>Password</label>
                                                        <input
                                                            type='text'
                                                            name='password'
                                                            id='password'
                                                            className='form-control m-0'
                                                            placeholder='Enter your password'
                                                            value={formData.password}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* tags */}
                                                    {/* <div className=' col-12 col-md-12 col-lg-12 col-xl-6 mb-3'>
                                                        <label htmlFor='tag'>Tags</label>
                                                        <Select
                                                            isMulti
                                                            name='tag'
                                                            id='tag'
                                                            options={tagOptions}
                                                            value={selectedTags}
                                                            className='basic-multi-select'
                                                            placeholder='Select tags...'
                                                            classNamePrefix='select'
                                                            onChange={(selectedOptions) => {
                                                                setSelectedTags(selectedOptions);
                                                            }}
                                                        />
                                                    </div> */}

                                                    {/* //* description */}
                                                    <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-1'>
                                                        <label htmlFor='description'>Description:</label>
                                                        <textarea
                                                            value={formData.description}
                                                            onChange={handleChange}
                                                            className='form-control'
                                                            name='description'
                                                            id='description'
                                                            rows={4}
                                                            placeholder='Enter description (max 300 words)'
                                                        />
                                                        <div className='text-end text-sm text-gray-500 mt-1'>
                                                            {formData.description.trim().split(/\s+/).filter(Boolean).length} / 300 words
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    {/* //* gallery image */}
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-between rounded-2 mb-3 px-3 py-2" style={{ background: '#e8fff4' }}>
                                                    <label htmlFor="email" className="mb-0 fw-semibold">Business Images</label>
                                                </div>
                                                <div
                                                    onClick={handleUploadClick}
                                                    className='d-flex flex-column   align-items-center justify-content-center'
                                                    style={{
                                                        border: '2px dashed #aaa',
                                                        borderRadius: '10px',
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#f9f9f9',
                                                        minHeight: '150px',
                                                    }}
                                                >
                                                    {images.length === 0 ? (
                                                        <div>
                                                            <strong>Click to upload images.</strong>
                                                            <p className='mb-0'>Upload minimum 3 and maximum 20 images</p>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                                                                {images.map((img, index) => (
                                                                    <div key={index} style={{ position: 'relative' }}>
                                                                        <img
                                                                            src={img.preview}
                                                                            alt='preview'
                                                                            width='100'
                                                                            height='100'
                                                                            style={{ objectFit: 'cover', borderRadius: '8px' }}
                                                                        />
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleRemoveImage(index);
                                                                            }}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '-5px',
                                                                                right: '-5px',
                                                                                background: '#c99449',
                                                                                color: 'white',
                                                                                border: 'none',
                                                                                borderRadius: '50%',
                                                                                width: '20px',
                                                                                height: '20px',
                                                                                fontSize: '14px',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className='mt-2'>
                                                                <strong>Click to upload more images</strong>
                                                                <p className="mb-0">You can upload {20 - images.length} more images</p>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                <input
                                                    type="file"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.webp"
                                                    style={{ display: 'none' }}
                                                    ref={fileInputRef}
                                                    onChange={handleImageChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* services */}
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="p-6 bg-gray-50 min-h-screen flex flex-col items-center">
                                                    <div className={`d-flex align-items-center justify-content-between rounded-2 ${services.length > ZERO && 'mb-3'} px-3 py-2`} style={{ background: '#e8fff4' }}>
                                                        <label htmlFor="email" className="mb-0 fw-semibold">Services</label>
                                                        {(services.length < 5) && (
                                                            <button className="btn btn-success" onClick={handleAddService}>
                                                                Add
                                                            </button>
                                                        )}
                                                    </div>

                                                    <div className="row">
                                                        {services.map((service) => (
                                                            <div key={service.id} className="col-12 col-md-4 mb-3">
                                                                <div className="bg-white p-6 rounded-lg shadow w-full max-w-lg space-y-4 relative">

                                                                    {/* Remove Icon */}
                                                                    {
                                                                        services.length > 1 && (
                                                                            <button
                                                                                className="btn bg-danger  close-vendor-btn  text-white p-1 rounded-circle"
                                                                                onClick={() => handleRemoveService(service.id)}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        )
                                                                    }

                                                                    <div className="p-3 mb-3">
                                                                        <div
                                                                            style={{
                                                                                position: 'relative',
                                                                                width: '100%',
                                                                                aspectRatio: '4 / 3',
                                                                                marginTop: '6px',
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={service.image}
                                                                                alt="Service"
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '100%',
                                                                                    objectFit: 'cover',
                                                                                    border: '1px solid #ccc',
                                                                                    borderRadius: '8px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                                onClick={() => document.getElementById(`upload-photo-${service.id}`).click()}
                                                                            />
                                                                            <label
                                                                                htmlFor={`upload-photo-${service.id}`}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '-8px',
                                                                                    left: '-10px',
                                                                                    background: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    padding: '3px 6px',
                                                                                    fontSize: '13px',
                                                                                    cursor: 'pointer',
                                                                                    boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                                                                                    transform: 'rotate(254deg)',
                                                                                }}
                                                                            >
                                                                                🖉
                                                                            </label>
                                                                            <input
                                                                                type="file"
                                                                                id={`upload-photo-${service.id}`}
                                                                                style={{ display: 'none' }}
                                                                                accept="image/*"
                                                                                onChange={(e) => handleFileChange(e, service.id)}
                                                                            />
                                                                        </div>

                                                                        <div className="row mt-2">
                                                                            <div className='col-12 col-md-12 col-lg-12'>
                                                                                <label htmlFor={`Name-${service.id}`}>Service</label>
                                                                                <input
                                                                                    type="text"
                                                                                    name="service_name"
                                                                                    id={`Name-${service.id}`}
                                                                                    className="form-control m-0 font-size-16"
                                                                                    placeholder='Enter service name'
                                                                                    value={service.name || ''}
                                                                                    onChange={(e) => handleInputChange(e, service.id, 'name')}
                                                                                />
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className='d-flex align-items-center justify-content-end'>
                                    <button className='btn btn-primary' onClick={executeCreateVendorApi} disabled={disableButton}>
                                        {!loading ? 'Create' : <Loader />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default UpdateVendor;